import React from 'react';
import Select from './Select';

const options = [
    { value: '', label: 'None' },
    { value: '00:5:00', label: '0:05' },
    { value: '00:10:00', label: '0:10' },
    { value: '00:15:00', label: '0:15' },
    { value: '00:20:00', label: '0:20' },
    { value: '00:25:00', label: '0:25' },
    { value: '00:30:00', label: '0:30' },
    { value: '00:35:00', label: '0:35' },
    { value: '00:45:00', label: '0:45' },
    { value: '00:50:00', label: '0:50' },
    { value: '00:55:00', label: '0:55' },
    { value: '01:00:00', label: '1:00' },
    { value: '01:15:00', label: '1:15' },
    { value: '01:30:00', label: '1:30' },
    { value: '01:45:00', label: '1:45' },
    { value: '02:00:00', label: '2:00' },
    { value: '02:30:00', label: '2:30' },
    { value: '03:30:00', label: '3:30' },
    { value: '04:00:00', label: '4:00' },
    { value: '04:30:00', label: '4:30' },
    { value: '05:00:00', label: '5:00' },
];

const Duration = (props) => {
    
    return <>
        <Select {...{options, ...props}} />
    </>
}

export default Duration;

export {
    options as durationOptions
}